<div *transloco="let t" class="onboarding-page-container">
  <div class="title">
    <span>
      {{ t('onboarding.firstPage.partOne') }}
    </span>
    <lib-pill-logo [companyName]="companyName()" [companyLogo]="companyLogo()" [size]="Size.BIG"></lib-pill-logo>
    <span>
    {{ t('onboarding.firstPage.partTwo') }}
    </span>
    <lib-pill-loyalty [loyaltyScore]="(loyaltyScore() || 0)"
                      [loyaltyLevel]="getLoyaltyLevel(loyaltyScore() || 0)"
                      [size]="Size.BIG">
    </lib-pill-loyalty>
  </div>
  <img class="star" ngSrc="assets/images/onboarding/star-multicolored.png" priority alt="multicolored start"
       height="246"
       width="162">
</div>
